var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcahnge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_105_3259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.60001 32.2672C1.60001 33.3517 2.0308 34.3917 2.79761 35.1585C3.56443 35.9253 4.60445 36.3561 5.68889 36.3561C6.77334 36.3561 7.81336 35.9253 8.58018 35.1585C9.34699 34.3917 9.77778 33.3517 9.77778 32.2672C9.77778 31.1828 9.34699 30.1428 8.58018 29.376C7.81336 28.6091 6.77334 28.1784 5.68889 28.1784C4.60445 28.1784 3.56443 28.6091 2.79761 29.376C2.0308 30.1428 1.60001 31.1828 1.60001 32.2672ZM30.2222 7.73391C30.2222 8.81835 30.653 9.85837 31.4198 10.6252C32.1867 11.392 33.2267 11.8228 34.3111 11.8228C35.3956 11.8228 36.4356 11.392 37.2024 10.6252C37.9692 9.85837 38.4 8.81835 38.4 7.73391C38.4 6.64947 37.9692 5.60944 37.2024 4.84263C36.4356 4.07581 35.3956 3.64502 34.3111 3.64502C33.2267 3.64502 32.1867 4.07581 31.4198 4.84263C30.653 5.60944 30.2222 6.64947 30.2222 7.73391Z",
    stroke: "#333333",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3111 11.8223V22.0445C34.3111 24.7556 33.2341 27.3557 31.3171 29.2727C29.4001 31.1898 26.8 32.2668 24.0889 32.2668H17.9556M17.9556 32.2668L24.0889 26.1334M17.9556 32.2668L24.0889 38.4001M5.6889 28.1779V17.9557C5.6889 15.2446 6.76588 12.6445 8.68292 10.7275C10.6 8.81041 13.2 7.73343 15.9111 7.73343H22.0445M22.0445 7.73343L15.9111 1.6001M22.0445 7.73343L15.9111 13.8668",
    stroke: "#333333",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_3259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcahnge);
export default __webpack_public_path__ + "static/media/Excahnge.97d331e6c158d08b015f86de5718e401.svg";
export { ForwardRef as ReactComponent };